import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import {
  convertTimeString,
  getNextOpeningTime,
  getStoreStatus,
  magicStrings,
} from '../utils';
import useActiveStore from '../../../hooks/useActiveStore';
import { StoreDetails } from '../ActiveStoreLocation/styles';

const getHoursSecondLine = (isOpen, locale, businessHours) => {
  if (!isOpen) {
    return getNextOpeningTime(
      businessHours,
      businessHours[0].openingTime,
      locale,
    );
  }
  return `- ${magicStrings.storeListingTitleCloses(locale)} ${convertTimeString(businessHours[0].closingTime, locale)}`;
};
const ActiveStoreDetails = () => {
  const { locale } = useIntl();
  const { activeStore } = useActiveStore();

  const isOpen = useMemo(() => {
    if (activeStore) {
      if (activeStore.commonInfo.businessHours.length > 0) {
        const status = getStoreStatus(
          activeStore.commonInfo.businessHours[0].openingTime,
          activeStore.commonInfo.businessHours[0].closingTime,
        );
        return !!status && !activeStore.commonInfo.businessHours[0].closed;
      }
    }
    return false;
  }, [activeStore]);

  const isTempClosed = useMemo(() => {
    if (activeStore) {
      if (activeStore.commonInfo.businessHours.length === 0) {
        return true;
      }
    }
    return false;
  }, [activeStore]);

  if (!activeStore) {
    return null;
  }
  const businessHours = activeStore?.commonInfo?.businessHours;
  const storeListingTitle = !isOpen
    ? magicStrings.storeListingTitleClosed(locale)
    : magicStrings.storeListingTitleOpen(locale);
  const isStoreClosedAllDay = !(
    !isTempClosed && businessHours?.length > 0
    && businessHours[0].openingTime
    && businessHours[0].closingTime
  );
  return (
    <StoreDetails>
      {isTempClosed
        && (locale === 'en'
          ? 'Connect with a Virtual Mobilist'
          : 'Communiquez avec un Mobiliste virtuel')}
      {isStoreClosedAllDay ? (
        <>{magicStrings.storeListingTitleClosedAllDay(locale)}</>
      ) : (
        <>
          <strong className="green">
            {storeListingTitle}
          </strong>
          {' '}
          {getHoursSecondLine(isOpen, locale, businessHours)}
        </>
      )}
    </StoreDetails>
  );
};

export default ActiveStoreDetails;
